<article>
  <header>
    <strong>Ranking Categorias Mencionadas</strong>
  </header>
  <main>
    <app-bar-chart [loading]="isLoading" [error]="error"></app-bar-chart>
  </main>
</article>
